module.exports = __webpack_public_path__ + "img/tool-empty-state.168eedad.svg";